import styled, { css } from "styled-components";
interface DividerProps {
  direction: "v" | "h";
  height?: string;
  width?: string;
  margin?: string;
  padding?: string;
}

export const Divider = styled.div<DividerProps>`
  ${p =>
    p.direction === "h"
      ? css`
          width: ${p.width || "100%"};
          height: ${p.height || "1px"};
          margin: ${p.margin || "0.5rem 0"};
        `
      : css`
          width: ${p.width || "1px"};
          height: ${p.height || "100%"};
          margin: ${p.margin || "0 0.5rem"};
        `}
  background-color: ${p => p.theme.colors.divider};
  padding: ${p => p.padding && `padding:${p.padding}`};
`;
